import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Helmet } from "react-helmet";
import { Toaster } from "./components/ui/toaster";
import Home from "./pages/Home";
import About from "./pages/About";
import Services from "./pages/Services";
import Projects from "./pages/Projects";
import Blog from "./pages/Blog";
import BlogPost from "./pages/BlogPost";
import Contact from "./pages/Contact";
import Navigation from "./components/Navigation";
import Footer from "./components/Footer";
import "./App.css";

// Organization Schema JSON-LD for site-wide SEO
const organizationSchema = {
  "@context": "https://schema.org",
  "@type": "GeneralContractor",
  "@id": "https://oracleprojectgroup.com/#organization",
  "name": "Oracle Project Group",
  "description": "Commercial construction excellence in Toronto & GTA. Specializing in interior fit-outs, design-build, and general contracting services.",
  "url": "https://oracleprojectgroup.com",
  "logo": "https://customer-assets.emergentagent.com/job_build-marble/artifacts/fr2rv7oy_Color%20logo%20-%20no%20background.png",
  "image": "https://customer-assets.emergentagent.com/job_build-marble/artifacts/fr2rv7oy_Color%20logo%20-%20no%20background.png",
  "telephone": "+16476318914",
  "email": "sarangan@oracleprojectgroup.com",
  "priceRange": "$$$$",
  "address": {
    "@type": "PostalAddress",
    "addressLocality": "Toronto",
    "addressRegion": "ON",
    "addressCountry": "CA"
  },
  "geo": {
    "@type": "GeoCoordinates",
    "latitude": "43.6532",
    "longitude": "-79.3832"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.9",
    "reviewCount": "47",
    "bestRating": "5",
    "worstRating": "1"
  },
  "areaServed": [
    { "@type": "City", "name": "Toronto" },
    { "@type": "Place", "name": "Greater Toronto Area" },
    { "@type": "City", "name": "Mississauga" },
    { "@type": "City", "name": "Vaughan" },
    { "@type": "City", "name": "Markham" },
    { "@type": "City", "name": "Brampton" },
    { "@type": "City", "name": "Richmond Hill" }
  ],
  "openingHoursSpecification": {
    "@type": "OpeningHoursSpecification",
    "dayOfWeek": ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"],
    "opens": "08:00",
    "closes": "18:00"
  },
  "foundingDate": "2014",
  "slogan": "Commercial Construction Excellence",
  "knowsAbout": [
    "Commercial Construction",
    "Interior Fit-Out",
    "Design-Build",
    "General Contracting",
    "Office Renovation",
    "Project Management"
  ],
  "sameAs": [
    "https://www.linkedin.com/company/oracleprojectgroup",
    "https://www.facebook.com/oracleprojectgroup"
  ]
};

function App() {
  return (
    <div className="App">
      <Helmet>
        <script type="application/ld+json">
          {JSON.stringify(organizationSchema)}
        </script>
      </Helmet>
      <BrowserRouter>
        <Navigation />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/services" element={<Services />} />
          <Route path="/projects" element={<Projects />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/blog/:id" element={<BlogPost />} />
          <Route path="/contact" element={<Contact />} />
        </Routes>
        <Footer />
        <Toaster />
      </BrowserRouter>
    </div>
  );
}

export default App;